import Layout from 'layouts/Default'
import {
  Box,
  Button,
  Collapse,
  Grid,
  Pagination,
  Paper,
  Stack as ButtonGroup,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import Breadcrumbs from 'components/Breadcrumbs'
import Label from 'components/Label'
import { StyledBoxContainerTitle as ContainerTitle } from 'pages/SearchTeenager/styles'
import React, { FC, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import {
  TeenagerRecordAuditDefaultValues,
  TeenagerRecordAuditSchema,
  TeenagerRecordAuditType,
} from '../../../types/teenager-record-audit.type'
import { zodResolver } from '@hookform/resolvers/zod'
import FormInput from 'components/FormInput'
import InputDatePicker from 'components/FormInputDatePicker'
import { FormInputSelect, ItemOption } from 'components/FormInputSelect'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import {
  TeenagerRecordAuditItem,
  useAudit,
  useTeenagerRecordAudit,
} from 'pages/Report/TeenagerRecordAudit/hooks/teenager-record-audit.hook'
import { StyledLineTeengaer } from 'pages/Report/TeenagerRecordAudit/styles'
import dayjs from 'dayjs'
import { StyledTableCell } from 'pages/TeenagersRecord/components/TabFamiliarReference/components/TableData/styles'
import TableCell from '@mui/material/TableCell'
import AddIcon from '@mui/icons-material/Add'
import EditRoundedIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { EmptyList } from 'pages/TeenagersEdit/components/TabFamiliarReference/components/EmptyList'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import DownloadIcon from '@mui/icons-material/Download'

const acaoOptions: ItemOption[] = [
  { value: 'I', label: 'Inserção' },
  { value: 'U', label: 'Alteração' },
  { value: 'D', label: 'Exclusão' },
]

const funcionalidadeOptions: ItemOption[] = [
  { value: 'mac-func-oitiva_finalizar', label: 'Finalizar Oitiva' },
  { value: 'mac-func-ficha_adolescente_edita', label: 'Alterar Ficha do Adolescente' },
]

export const TeenagerRecordAuditPage = () => {
  const [close, setClose] = useState(true)
  const [loaded, setLoaded] = useState<boolean>(false)
  const { setValue, control, handleSubmit, reset, watch } = useForm<TeenagerRecordAuditType>({
    resolver: zodResolver(TeenagerRecordAuditSchema),
    defaultValues: TeenagerRecordAuditDefaultValues,
  })

  const [filter, setFilter] = useState<TeenagerRecordAuditType | undefined>(undefined)

  const dataInicialWatch = watch('dataInicial')
  const dataFinalWatch = watch('dataFinal')

  const { page, teenagerRecordAuditItem, totalOfPages, handleNewPage, handleBuscarAdolescentes } =
    useTeenagerRecordAudit()

  useEffect(() => {
    if (dayjs(dataInicialWatch).isAfter(dataFinalWatch)) {
      setValue('dataFinal', '')
    }
  }, [dataInicialWatch])

  const handlePage = (page: number) => {
    if (filter) {
      handleNewPage(null, page)
      handleSubmit(async (data) => {
        await handleBuscarAdolescentes(data, page)
      })()
    }
  }

  const handleReset = () => {
    reset(TeenagerRecordAuditDefaultValues)
  }

  const handlePesquisar = async (data?: TeenagerRecordAuditType) => {
    await handleBuscarAdolescentes(data, 0)
    handleNewPage(null, 0)
    setFilter(data)
    setLoaded(true)
    setClose(true)
    setTimeout(() => setClose(false), 2000)
  }

  return (
    <Layout>
      <Grid container item xs={12} sx={{ mb: 2 }}>
        <Breadcrumbs>
          <Label text='Relatório Auditoria' bold v='body1' />
        </Breadcrumbs>
      </Grid>

      <Grid container item direction='column' spacing={4}>
        <Grid item xs={12}>
          <ContainerTitle>
            <Label text='RELATÓRIO AUDITORIA - ATUALIZAÇÃO DE DADOS DO ADOLESCENTE' v='h6' bold />
          </ContainerTitle>
        </Grid>
      </Grid>

      <Grid item direction='column' spacing={4}>
        <form onSubmit={handleSubmit(handlePesquisar)}>
          <Grid container item spacing={2} xs={12}>
            <Grid item xs={12} />
            <Grid item lg={3} md={6} xs={12}>
              <InputDatePicker
                control={control}
                name={`dataInicial`}
                label='Data da Atualização*'
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <InputDatePicker
                control={control}
                name={`dataFinal`}
                label='Até*'
                minDate={dayjs(dataInicialWatch)}
                disabled={!dataInicialWatch}
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <FormInputSelect control={control} name='acao' label='Ação' options={acaoOptions} />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <FormInputSelect
                control={control}
                name='funcionalidade'
                label='Funcionalidade'
                options={funcionalidadeOptions}
              />
            </Grid>
            <Grid item lg={5} xs={12}>
              <FormInput
                name='nomeAdolescente'
                control={control}
                label='Nome do adolescente*'
                placeholder='Informe o nome do adolescente'
                maxLength={60}
              />
            </Grid>
            <Grid item lg={4} xs={12}>
              <FormInput
                name='usuario'
                control={control}
                label='Usuário'
                placeholder='Informe o usuário'
                maxLength={60}
              />
            </Grid>
            <Grid item xs={12}>
              <ButtonGroup direction='row' spacing={2} sx={{ mt: 1 }}>
                <Button
                  variant='outlined'
                  color='secondary'
                  onClick={() => {
                    handleReset()
                    setLoaded(false)
                    setFilter(undefined)
                  }}
                >
                  Limpar
                </Button>
                <Button
                  type={'submit'}
                  startIcon={<SearchRoundedIcon />}
                  variant='contained'
                  color='secondary'
                >
                  Pesquisar
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </form>
        <Grid container item spacing={2} xs={12}>
          <Grid item xs={12} />
          {loaded &&
            (teenagerRecordAuditItem && teenagerRecordAuditItem.length > 0 ? (
              <>
                <Grid item xs={12} />
                <Grid item xs={12} />
                <Grid item xs={12}>
                  <span>Resultados da busca:</span>
                  {teenagerRecordAuditItem.map((item, i) => (
                    <TeenagerItemComponent data={item} filter={filter} key={i} close={close} />
                  ))}
                  <Box
                    display={'flex'}
                    alignItems='center'
                    justifyContent='center'
                    marginTop={'2rem'}
                  >
                    <Pagination
                      page={page + 1}
                      count={totalOfPages}
                      variant='outlined'
                      shape='rounded'
                      onChange={(e, newPage) => handlePage(newPage - 1)}
                    />
                  </Box>
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <EmptyList />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Layout>
  )
}

type TeenagerItemComponentProps = {
  data: TeenagerRecordAuditItem
  filter?: TeenagerRecordAuditType
  close: boolean
}

const TeenagerItemComponent: FC<TeenagerItemComponentProps> = ({ data, filter, close }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (close) {
      setOpen(false)
    }
  }, [close])

  return (
    <>
      <StyledLineTeengaer display={'flex'} flexDirection={'row'} onClick={() => setOpen(!open)}>
        <ExpandMoreIcon sx={{ marginRight: '1rem' }} />
        <Grid container alignItems={'center'} spacing={2}>
          <Grid item lg={4} md={6} sm={12} xs={12} display={'flex'} flexDirection={'column'}>
            <Typography color={'secondary'} variant={'body2'}>
              <b>Nome do Adolescente:</b>
            </Typography>
            <Typography variant={'body2'} sx={{ marginLeft: '0.25rem' }}>
              <b>{data.pessoaFisica.nome}</b>
            </Typography>
          </Grid>
          <Grid item lg={2} md={6} sm={12} xs={12} display={'flex'} flexDirection={'column'}>
            <Typography color={'secondary'} variant={'body2'}>
              <b>Data de nascimento:</b>
            </Typography>
            <Typography variant={'body2'} sx={{ marginLeft: '0.25rem' }}>
              <b>
                {dayjs(data.pessoaFisica.dataNascimento).isValid()
                  ? dayjs(data.pessoaFisica.dataNascimento).format('DD/MM/YYYY')
                  : ''}
              </b>
            </Typography>
          </Grid>
          <Grid item lg={2} md={6} sm={12} xs={12} display={'flex'} flexDirection={'column'}>
            <Typography color={'secondary'} variant={'body2'}>
              <b>Gênero:</b>
            </Typography>
            <Typography variant={'body2'} sx={{ marginLeft: '0.25rem' }}>
              <b>{data.pessoaFisica.genero?.nome || ''}</b>
            </Typography>
          </Grid>
          <Grid item lg={4} md={6} sm={12} xs={12} display={'flex'} flexDirection={'column'}>
            <Typography color={'secondary'} variant={'body2'}>
              <b>Nome da Mãe:</b>
            </Typography>
            <Typography variant={'body2'} sx={{ marginLeft: '0.25rem' }}>
              <b>{data.pessoaFisica.nomeMae || ''}</b>
            </Typography>
          </Grid>
        </Grid>
      </StyledLineTeengaer>
      <Collapse in={open} timeout={500} unmountOnExit>
        <AuditItemComponent data={data} open={open} filter={filter} close={close} />
      </Collapse>
    </>
  )
}

type AuditItemComponentProps = {
  data: TeenagerRecordAuditItem
  filter?: TeenagerRecordAuditType
  close: boolean
  open: boolean
}

const AuditItemComponent: FC<AuditItemComponentProps> = ({ data, filter, close }) => {
  const {
    handleBuscarDados,
    handleDownloadAuditoria,

    page,
    auditItem,
    handleNewPage,
    totalOfElements,
    handleRowsPerPage,
    rowsPerPage,
    rowsOptions,
  } = useAudit(data.id)

  useEffect(() => {
    ;(async () => {
      if (filter && filter?.dataInicial !== '') {
        await handleBuscarDados(filter, page, rowsPerPage)
      }
    })()
  }, [filter])

  const handlePage = async (newPage: number, newRowsPerPage?: any) => {
    handleNewPage(null, newPage)
    if (newRowsPerPage) {
      handleRowsPerPage(newRowsPerPage)
    }
    if (filter && filter?.dataInicial !== '') {
      await handleBuscarDados(filter, newPage, newRowsPerPage?.target?.value || rowsPerPage)
    }
  }

  const getIcon = (tipoEvento?: string) => {
    switch (tipoEvento) {
      case 'I':
        return (
          <Tooltip title='Inserção'>
            <AddIcon color={'secondary'} fontSize={'small'} />
          </Tooltip>
        )
      case 'U':
        return (
          <Tooltip title='Alteração'>
            <EditRoundedIcon color={'secondary'} fontSize='small' />
          </Tooltip>
        )
      case 'D':
        return (
          <Tooltip title='Exclusão'>
            <DeleteIcon color={'secondary'} fontSize={'small'} />
          </Tooltip>
        )
      default:
        return null
    }
  }

  const getFuncionalidade = (funcionalidade?: string) => {
    if (!funcionalidade) return null
    const func = funcionalidadeOptions.find((item) => item.value === funcionalidade)
    return func?.label
  }

  return (
    <Paper variant='outlined'>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Funcionalidade</StyledTableCell>
              <StyledTableCell>Campo</StyledTableCell>
              <StyledTableCell>Dado Atual</StyledTableCell>
              <StyledTableCell>Dado Anterior</StyledTableCell>
              <StyledTableCell>Data e Hora da Alteração</StyledTableCell>
              <StyledTableCell>Usuário</StyledTableCell>
              <StyledTableCell align={'center'}>Ação Realizada</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {auditItem.map((item, i) => (
              <TableRow hover key={i}>
                <TableCell>{getFuncionalidade(item.funcionalidade)}</TableCell>
                <TableCell>{item.campo}</TableCell>
                <TableCell>{item.valorNovo}</TableCell>
                <TableCell>{item.valorAntigo}</TableCell>
                <TableCell>{dayjs(item.dataEvento).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                <TableCell>{item.usuario}</TableCell>
                <TableCell align={'center'}>{getIcon(item.tipoEvento)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box display='flex' flexDirection='row'>
        <Box flexGrow={1} display={'flex'} alignItems={'center'} marginLeft={'0.5rem'}>
          <Button
            startIcon={<DownloadIcon />}
            variant={'contained'}
            color={'secondary'}
            size={'medium'}
            onClick={() => handleDownloadAuditoria(filter)}
            disabled={totalOfElements === 0}
          >
            Download
          </Button>
        </Box>
        <TablePagination
          labelRowsPerPage='Linhas por página: '
          labelDisplayedRows={({ from, to, count }) => {
            return `Linhas ${from}-${to} de um total de ${count} itens.`
          }}
          rowsPerPageOptions={rowsOptions}
          count={totalOfElements}
          rowsPerPage={rowsPerPage}
          onPageChange={(e, p) => handlePage(p)}
          page={page}
          component='div'
          onRowsPerPageChange={(e) => handlePage(0, e)}
        />
      </Box>
    </Paper>
  )
}
